export default {
  uploading: 'Uploading...',
  loading: 'Loading...',
  refreshRetry: 'Refresh Retry',
  // Common
  common: {
    home: 'Home',
    assistant: 'AI Tutor',
    signIn: 'Check In',
    mine: 'Me',
    search: 'Search',
    searchCourse: 'Search Courses',
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    prev: 'Previous',
    loading: 'Loading...',
    noData: 'No Data',
    success: 'Success',
    failed: 'Failed',
    error: 'Error',
    warning: 'Warning',
    tip: 'Tip',
    close: 'Close',
    view: 'View',
    download: 'Download',
    upload: 'Upload',
    reset: 'Reset',
    refresh: 'Refresh',
    complete: 'Complete',
    all: 'All',
    selectAll: 'Select All',
    more: 'More',
    pleaseEnter: 'Please enter',
    correctAnswer: 'Correct Answer',
    gotIt: 'Got it'
  },
  unit: {
    agent: '{num} agents',
    kps: '{num}',
    errorReview: '{num} Error Reviews'
  },

  login: {
    // Welcome title
    welcomeTitle: 'Welcome to log in to U课AI',
    loginIllustration: 'Login Illustration',

    // Login modes
    accountLogin: 'Student ID Login',
    phoneLogin: 'Phone Login',
    phoneNumberLogin: 'Phone Number Login',
    wechatLogin: 'WeChat Login',
    bindAccount: 'Bind Account',
    rebindAccount: 'Bind Account Information',
    bindAccountInfo: 'Bind Account Information',
    rebindAccountInfo: 'Rebind Account Information',
    verifyCodeLogin: 'Login with Verification Code',

    // Form labels
    selectSchool: 'Select School',
    studentId: 'Student ID',
    password: 'Password',
    phoneNumber: 'Phone Number',
    phoneNumberLabel: 'Phone Number',
    verifyCode: 'Verification Code',
    school: 'School',
    name: 'Name',

    // Placeholders
    pleaseSelectSchool: 'Please select a school',
    pleaseInputStudentId: 'Please enter student ID',
    pleaseInputPassword: 'Please enter password',
    pleaseInputPhone: 'Please enter phone number',
    pleaseInputPhoneNumber: 'Please enter your phone number',
    pleaseInputVerifyCode: 'Please enter the verification code',
    pleaseInputName: 'Please enter name',

    // Tips
    bindStudentIdTip: 'Please bind your student ID to complete login',

    // Buttons
    loginBtn: 'Login',
    getVerifyCode: 'Get Verification Code',
    resend: 'Resend',
    contactService: 'Contact Customer Service',
    contactCustomerService: 'Contact Customer Service',
    backToWechatScan: 'Back to WeChat Scan',
    backToPhoneLogin: 'Back to Phone Login',
    confirmPassword: 'Confirm Password',
    refreshQrCode: 'Refresh QR Code',
    generatingQrCode: 'Generating QR Code...',
    complete: 'Complete',
    gotIt: 'Got it',
    later: 'Later',
    updatePassword: 'Update Password',
    verifyPassword: 'Password Verification',
    loginWithStudentId: 'Log in with Student ID',

    // Checkbox
    agreeProtocol: 'I have read and agree to ',
    userAgreement: '《UClass AI User Agreement》',
    and: ' and ',
    privacyPolicy: '《Privacy Policy》',
    loginAgreement: 'Logging in means you agree to the 《UClass AI User Agreement》 and 《Privacy Policy》',
    scanLoginAgreement: 'Logging in via QR code means you agree to the ',

    // Tips
    scanToLogin: 'Please scan with WeChat',
    accountBound: 'This WeChat account is already bound',
    boundPhone: 'Bound phone number',
    loginWithPhone: 'Login to your profile to change password',
    defaultPasswordTip: 'You are using the default password',
    changePasswordNow: 'Change Now',
    changePasswordLater: 'Later',
    contactServiceTitle: 'Contact Support',
    workingHours: 'Working Hours',
    workingHoursValue: 'Mon-Fri 9:00-18:00',
    servicePhone: 'Phone',
    serviceEmail: 'Email',

    // Validation tips
    pleaseSelectSchoolTip: 'Please select a school',
    pleaseInputStudentIdTip: 'Please enter your student ID',
    pleaseInputPasswordTip: 'Please enter your password',
    pleaseInputPhoneTip: 'Please enter your phone number',
    pleaseInputCorrectPhone: 'Please enter a valid phone number',
    pleaseInputVerifyCodeTip: 'Please enter the verification code',
    pleaseInputCorrectVerifyCode: 'Please enter a valid verification code',
    pleaseInputNameTip: 'Please enter your name',
    pleaseAgreeProtocol: 'Please agree to the User Agreement and Privacy Policy first',
    pleaseInputField: 'Please enter',

    // Success tips
    loginSuccess: 'Login successful',
    verifyCodeSent: 'Verification code sent',

    // Error tips
    loginFailed: 'Login failed, please try again later',
    loginFailedNoToken: 'Login failed: No token received',
    verifyCodeSendFailed: 'Failed to send verification code',
    verifyCodeSendFailedRetry: 'Failed to send verification code, please try again later',
    verifyCodeError: 'Incorrect verification code, please re-enter',
    verifyCodeValidateFailed: 'Verification code validation failed, please try again',
    verifyCodeRequired: 'Please get the verification code first',
    verifyCodeInputRequired: 'Please enter the verification code',
    verifyCodeExpired: 'Verification Code Expired',
    verifyCodeExpiredMessage: 'The phone verification code has expired. Please go back to get a new verification code before binding.',
    backToReVerify: 'Back to Re-verify',
    studentIdNotFound: 'No matching student ID found under this school. Please verify it or log in with your phone number',
    invalidPassword: 'Invalid password',
    passwordVerifyFailed: 'Invalid password. Cannot rebind to log in with phone number',
    notModifiedDefaultPassword: 'You haven\'t modified the default password yet. For the security of your account, please modify the password first',
    notBoundPhone: 'You have not yet bound your phone number. Please bind it first',
    verifyStudentIdName: 'Please verify the name corresponding to your student ID, or log in with your student ID and password. For any questions, please contact customer service',
    studentIdAlreadyBound: 'The current student ID is already bound to another WeChat ID. You need to verify the password to rebind, or log in with the original phone number\'s verification code',
    studentIdBoundToPhone: 'This student ID is already bound to phone number {phone}. Verify your password to rebind, or log in with the original phone number\'s verification code',
    rebindPasswordRequired: 'The current student ID is already bound to another WeChat ID. You need to verify the password to rebind',
    getSchoolListFailed: 'Failed to get school list',
    getSchoolListFailedRetry: 'Failed to get school list, please try again later',
    getUserInfoFailed: 'Failed to get user information',
    getUserInfoFailedRetry: 'Failed to get user information, please login again',
    nameNotMatch: 'Name does not match, please check the name you entered',
    accountAlreadyBound: 'This student ID is already bound to phone number {phone}, please log in with your student ID and password',
    accountAlreadyBoundOther: 'This student ID is already bound to another phone number, please log in with your student ID and password',
    textLengthExceeded: 'Input exceeds 3000 character limit',
    wechatBindRequired: 'WeChat information not found, please scan the QR code again',
    bindInfoIncomplete: 'Please complete all binding information',
    bindSuccess: 'Binding successful',
    bindFailedNoToken: 'Binding failed: No valid credentials received',
    bindFailedNameNotMatch: 'Please verify the name corresponding to your student ID, or log in with your student ID and password. For any questions, please contact customer service',
    bindFailedAlreadyBound: 'This student ID is already bound to phone number {phone}, please log in with your student ID and password',
    bindFailed: 'Binding failed',
    bindFailedUnknown: 'Binding failed: Unknown result',
    bindFailedRetry: 'Binding failed, please try again later',
    phoneNotExistNeedBind: 'This phone number is not registered. Please bind your student ID',
    phoneBindRequired: 'Please complete phone number verification first',
    rebindTip: 'This student ID is already bound to phone number {phone}. You need to verify your password to rebind',
    rebindRequired: 'Please complete the binding process first',
    rebindSuccess: 'Rebinding successful',
    rebindFailedNoToken: 'Rebinding failed: No valid credentials received',
    rebindFailedRetry: 'Rebinding failed, please try again later',
    rebindStudentNotExist: 'Error, the student to be rebound does not exist',
    passwordIncorrect: 'Incorrect password',
    getQrCodeFailed: 'Failed to get QR code',
    getQrCodeFailedRetry: 'Failed to get QR code, please try again later',
    qrCodeExpired: 'QR code has expired, please refresh to get a new one',
    tenantDisabled: 'Tenant has been disabled',
    wechatLoginSuccess: 'WeChat login successful',
    accountDisabled: 'Your account has been disabled, please contact the administrator',
    wechatInfoFailed: 'Failed to get WeChat information, please scan the QR code again',

    // Language
    language: 'Language',
    switchLanguage: 'Switch Language',

    // Other login methods
    otherLoginMethods: 'Other Login Methods',
    notUseAccountLogin: 'If you don\'t want to use student ID login, you can choose other methods',
    notUsePhoneLogin: 'If you don\'t want to log in with your phone number, you can choose other methods',
    notUseWechatLogin: 'If you don\'t want to use WeChat login, you can choose other methods',

    // Contact support
    contactUs: 'Contact Support',
    customerServiceQrCode: 'Customer Service QR Code',
    longPressQrcode: 'Scan the QR code Add customer service WeChat',
    addServiceWechat: 'Add customer service WeChat',

    // WeChat login
    scanQrcodeToLogin: 'Use WeChat to scan the QR code below',
    useWechatScan: 'Use WeChat to scan the QR code below',

    // Tips title
    tips: 'Tips'
  },

  // Navigation Titles
  nav: {
    taskCenter: 'Task Center',
    mistakeExercise: 'Mistake Exercise',
    taskDetails: 'Task Details',
    signInDetails: 'Check-in Details',
    signInBreakdown: 'Check-in Breakdown'
  },

  task: {
    signIn: {
      reminder: 'Check-in Reminder',
      defaultCourseName: 'Course',
      defaultTaskName: 'Check-in',
      courseCheckInStarted: 'Check-in for 【{taskName}】 in 【{courseName}】 has started. Please complete it in time!',
      nthCheckInStarted: 'Round {round} check-in for 【{taskName}】 in 【{courseName}】 has started. Please complete it in time!',
      weekDay: 'Week {week}, Day {day}',
      weekOnly: 'Week {week}',
      countdown: 'Countdown: {time}',
      countdownLabel: 'Countdown:',
      checkInProgress: 'Check-in is in progress . please complete it promptly.',
      checkInEnded: 'Check-in has ended',
      goToCheckIn: 'Go to Check-in',
      cancel: 'Cancel',
      checkIn: 'Check In',
      details: 'Check-in Details',
      scanQrCodeTitle: 'Scan Check-in QR Code',
      scanQrCode: 'Please scan the QR code',
      enterCheckInCode: 'Please enter the check-in code',
      incorrectCode: 'Incorrect check-in code',
      invalidQRCode: 'Invalid check-in QR code',
      takePhoto: 'Take Photo',
      retakePhoto: 'Retake Photo',
      usePhoto: 'Use Photo',
      photoRequirement: 'Photo Requirement',
      codeRequired: 'Check-in code is required',
      nthTime: 'The {count}th Time',
      success: 'Check-in Successful',
      failed: 'Check-in Failed',
      networkError: 'Network Error',
      outOfRange: 'You are outside the valid check-in range and cannot complete this check-in.',
      outOfRangeLineOne: 'Out of the check-in range',
      outOfRangeLineTwo: 'Unable to check in',
      records: 'Check-in Records',
      weekdays: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      },
      weekdaysShort: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
      },
      calendarWeekTitle: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      dateFormat: 'MMMM D, YYYY',
      monthFormat: 'MMMM YYYY',
      status: {
        present: 'Present',
        absent: 'Absent',
        abnormal: 'Abnormal',
        leave: 'Leave',
        late: 'Late',
        success: 'Success',
        failed: 'Failed',
        pending: 'In Progress',
        signing: 'CheckIning'
      },
      breakdown: 'Check-in Breakdown',
      abnormalRecords: 'Abnormal Check-in Records',
      recordDetail: 'Week {week}, Day {day} | {count}th Check-in',
      summaryWithIndex: 'Week {week}, Day {day} {count}th Check-in',
      noTasksThisMonth: 'No tasks this month',
      startCheckIn: 'Start Check-in',
      abnormalReminderTitle: 'Check-in Reminder',
      abnormalTip: 'You have courses with incomplete or abnormal check-ins. Please contact your instructor promptly to resolve the issue.',
      abnormalWarning: 'You have courses with incomplete or abnormal check-ins. Please contact your instructor promptly to resolve the issue.',
      viewDetails: 'View Details',
      teacherHandled: 'Your instructor has updated the status to <{status}>',
      checkInType: '{count}th Check-in ({type})',
      checkedIn: 'Checked In',
      uncheckedIn: 'Not Checked In',
      roundLabel: 'Round {count}',
      noRoundData: 'No check-in rounds yet',
      startCheckInAt: 'Start Check-in: {time}',
      prev: 'Previous',
      next: 'Next',
      locating: 'Locating...',
      locatingWait: 'Locating, please wait...',
      retryLocate: 'Retry',
      locationAcquired: 'Location acquired',
      checkInPoint: 'check-in point',
      distanceToCheckInPoint: 'About {distance} m from "{name}"',
      enableLocationPermission: 'Please enable location permission and try again',
      enableCameraPermission: 'Please enable camera permission and try again',
      noCameraCheckInOnPc: 'No camera is available on this device. QR-code and photo check-in are not supported. Please use the WeChat Mini Program to check in.',
      noCameraCheckIn: 'No available camera detected',
      cameraUnavailable: 'Camera is temporarily unavailable. Please try again later.',
      photoFeatureDeveloping: 'Photo check-in is under development',
      nearby: 'Nearby',
      checkInCompletedAt: 'Checked in at {time}',
      clickToCheckIn: 'Please tap the button below to check in',
      browserNotSupport: 'Your browser does not support geolocation',
      browserLocationNotSupported: 'Browser does not support location',
      locationErrorTip: 'Location error. You can check in via the UKU AI WeChat Mini Program',
      permissionDenied: 'Please allow access to your location',
      positionUnavailable: 'Unable to retrieve location',
      timeout: 'Location request timed out',
      locationFailed: 'Failed to retrieve location',
      getDetailFailed: 'Failed to get check-in details',
      targetLocation: 'Target Location',
      monthDayFormat: 'MMM D',
      time: 'Time',
      location: 'Location',
      fullDateFormat: 'MMM D, dddd',
      noAbnormalRecords: 'No abnormal records',
      teacher: 'Teacher',
      nthSignIn: '{n}th Check-in',
      prevRecord: 'Previous',
      nextRecord: 'Next',
      type: {
        normal: 'Normal',
        ordinary: 'Normal',
        qrCode: 'QR Code',
        code: 'Code',
        photo: 'Photo',
        location: 'Location'
      },
      notFoundSignInTask: 'Check-in task does not exist or has been deleted'
    },
    callAndRush: {
      notStart: 'NOT START',
      selectionNotification: 'Selection Notification',
      callReason: 'Call Reason',
      rushReason: 'Quick Response Reason',
      youAreSelected: 'You\'ve been selected in {courseName} class!',
      youAreSelectedShort: 'You\'re selected!',
      prepareToAnswer: 'Please get ready to answer. Your instructor is waiting for your response.',
      prepareToAnswerShort: 'Please cooperate with your instructor~',
      notSelected: 'Not selected this time!',
      notSelectedHint: 'Not selected this time. Join actively next time~',
      rushAlert: 'Quick Response Alert',
      countdownStarted: 'Round {roundNum} quick response in {courseName} class has started!',
      goToRush: 'Go to Buzz-in',
      notParticipated: 'Not Participated',
      callSelected: 'Call Selected',
      callNotSelected: 'Not Selected',
      rushFailed: 'Buzz-in Failed',
      rushSuccessful: 'Buzz-in Successful',
      rushFailedMessage: 'Buzz-in Failed!',
      tryAgain: 'Try again next time!',
      rushSuccessMessage: 'Congratulations! Buzz-in Successful!',
      notParticipatedMessage: 'You did not participate in this buzz-in.',
      joinNextTime: 'Join actively next time!',
      go: 'Go',
      rush: 'Buzz',
      teacherRating: 'Teacher\'s Rating',
      comment: 'Comment',
      noRounds: 'No rounds yet',
      round: 'Round {num}',
      rushFailedRetry: 'Buzz-in failed, please retry',
      bannedTitle: 'You\'ve already buzzed in!',
      bannedHint: 'Each student can only participate once in this buzz-in task~',
      cancel: 'Cancel'
    },
    testTask: {
      finalExam: 'Final Exam',
      midtermExam: 'Midterm Exam',
      otherExam: 'Other Exam',
      duration: 'Duration: {0} minutes',
      forceSubmitDeadlineNotice: 'This exam ends at {0} and will be submitted automatically at that time.',
      startExam: 'Start Exam',
      exitAutoSubmitNote: 'Note: Exiting or closing will auto-submit.',
      countdown: 'Countdown',
      submitPaper: 'Submit',
      examEnded: 'Exam Ended',
      inProgressWarning: 'In progress, do not exit/close. Forced exit triggers auto-submit.',
      examTimeUp: 'Time is up. Your exam has been auto-submitted.',
      confirmSubmitTitle: 'Confirm Submit',
      confirmSubmitContent: 'Are you sure you want to submit? You cannot modify after submission.',
      exitWarningTitle: 'Exam In Progress',
      tabSwitchWarning: 'Please observe exam discipline',
      continueAnswering: 'Continue Answering',
      unfinishedTitle: 'Notice',
      unfinishedContent: 'You have {0} question(s) unfinished. Submit anyway?',
      totalScoreLabel: 'Total Score: {0} points',
      examInfo: 'Exam Information',
      examContent: 'Exam Content',
      examRequirement: 'Exam Requirements',
      examName: 'Exam Name',
      offlineNotice: 'Network disconnected. Answers saved locally and will sync after reconnecting.',
      reconnectedNotice: 'Reconnected. Answers synced.',
      localSubmittedNotice: 'Network still offline. Submitted locally; will sync to server after reconnecting.',
      resumeDraftTitle: 'Notice',
      resumeDraftContent: 'An unfinished answer record was detected. Continue?',
      resumeDraftContinue: 'Continue',
      resumeDraftDiscard: 'Discard',
      submittedTip: 'Submission complete',
      exitPromptTitle: 'Notice',
      exitPromptMain: 'Exam in progress. Do not exit or close the page.',
      exitPromptSub: 'Forced exit or close will trigger auto-submission.',
      exitBack: 'Back',
      exitSubmit: 'Submit',
      examResult: 'Exam Result'
    }
  },

  // Course
  course: {
    myCourses: 'My Courses',
    currentSemester: 'Current Term',
    courseName: 'Course Name',
    teacher: 'Teacher',
    teachingClass: 'Class',
    assistant24h: '24/7 AI Tutor',
    semester: 'Semester',
    fallSemester: 'Fall Semester',
    springSemester: 'Spring Semester',
    class: 'Class',
    classCode: 'Class Code',
    enterClassCode: 'Please enter class code',
    inviteJoinClass: 'invites you to join',
    joinClass: 'Join Class',
    courseInfo: 'Course Info',
    courseDetails: 'Course Details',
    chapters: 'Chapters',
    assignments: 'Assignments',
    exams: 'Exams',
    resources: 'Resources',
    courses: ' Courses',
    viewNow: 'View Now',
    historyCourses: 'History Courses',
    noCourses: 'No courses available'
  },

  // Home
  home: {
    // Banner text
    bannerTitle: 'Pocket-Sized Study Guru',
    bannerSubtitle: 'Always On · All Disciplines · Academic Companion',

    // Navigation area
    currentSemesterCourses: 'Current Courses',
    coursesCount: ' Courses',
    viewNow: 'View Now',
    joinClass: 'Join Class',
    scanToJoinClass: 'Scan to Join Class',
    goToScan: 'Scan QR Code',
    enterClassCode: 'Enter Class Code',
    historyCourses: 'Previous Courses',

    // Featured assistants
    featuredAssistants: 'Specialized Agent',
    goToAsk: 'Use it',
    noAssistantIntro: 'No introduction available',
    noAssistants: 'No Specialized Agent available',

    // Join class modal
    joinClassTitle: 'Join Class',
    classCodePlaceholder: 'Please enter the class code',
    classCodeError: 'Please enter the class code',
    classCodeFormatError: 'Invalid class code format',
    classNotFound: 'No class found',
    classNotExist: 'Class does not exist',
    returnBtn: 'Return',
    joinNow: 'Join Now',
    joinClassSuccess: 'Successfully joined class',
    joinClassFailed: 'Failed to join class',
    joinClassFailedRetry: 'Failed to join class, please try again later',

    // Pending classes
    waitJoinClassTitle: 'Pending Classes',
    acceptedJoinClass: 'Successfully joined class',
    rejectedInvitation: 'Invitation declined',
    acceptInvitation: 'Accept',
    rejectInvitation: 'Decline',
    unknownClass: 'Unknown Class',
    unknownCourse: 'Unknown Course',
    unknownTeacher: 'Unknown Teacher',
    teacherLabel: 'Teacher: ',
    termLabel: 'Term: ',
    classCodeLabel: 'Class Code: ',

    // Tip modals
    passwordTipTitle: 'Default Password Not Changed',
    passwordTipContent: 'You haven\'t modified the default password yet. For the security of your account, please modify the password first',
    phoneBindTipTitle: 'Phone Number Not Bound',
    phoneBindTipContent: 'You have not yet bound your phone number. Please bind it first',
    wechatBindTipTitle: 'WeChat Binding Reminder',
    wechatBindTipContent: 'You have not yet bound your WeChat. Please bind it first',
    later: 'Later',
    goToModify: 'Modify Now',
    goToBind: 'Bind Now',

    // Error messages
    unlistedError: 'You are not on the class roster, and this class does not allow other students to join;If you are a class student, please contact the teacher to join the class roster',
    limitedError: 'The class has reached its maximum capacity. If you are a student in this class, please contact your teacher to be added to the roster'
  },

  // User Center
  user: {
    personalCenter: 'Profile Center',
    changeAvatar: 'Edit',
    personalInfo: 'Personal Information',
    accountInfo: 'Account Information',
    school: 'School',
    college: 'College',
    major: 'Major',
    grade: 'Grade',
    changePassword: 'Password Reset',
    changePasswordTip: 'For the security of your account, please change the default password.',
    modify: 'Modify',
    bindPhone: 'Bind Mobile Phone Number',
    phoneStatus: 'Not Bound / Bound',
    changeBind: 'Rebind',
    bind: 'Bind Phone Number',
    notBound: 'Not Bound',
    language: 'Language',
    chinese: 'Chinese',
    logout: 'Log Out',
    changePasswordTitle: 'Password Reset',
    passwordRule: 'The password must be a combination of uppercase and lowercase letters and numbers, 8-16 characters in length.',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    pleaseInput: 'Please enter',
    pleaseInputPhone: 'Please enter your mobile phone number',
    pleaseInputCode: 'Please enter the verification code',
    bindPhoneTitle: 'Bind Mobile Phone Number',
    changePhoneTitle: 'Rebind Mobile Phone Number',
    getVerifyCode: 'Get Verification Code',
    verifyCode: 'Verification Code',
    phoneNumber: 'Mobile Phone Number',
    customerServiceQrCode: 'Customer Service QR Code',
    qrCodeTip: 'Scan the QR code Add customer service WeChat',
    logoutConfirm: 'Are you sure you want to log out?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    complete: 'Complete',
    // Password change related messages
    pleaseEnterOldPassword: 'Please enter old password',
    pleaseEnterNewPassword: 'Please enter new password',
    pleaseConfirmPassword: 'Please confirm new password',
    passwordMustBeValid: 'The password must be a combination of uppercase and lowercase letters and numbers, 8-16 characters in length',
    passwordMismatch: 'The passwords entered twice do not match',
    newPasswordCannotBeSame: 'The new password cannot be the same as the old password',
    passwordChangeSuccess: 'Password changed successfully',
    passwordChangeFailed: 'Password change failed',
    passwordChangeFailedRetry: 'Password change failed, please try again later',
    // Phone number related messages
    pleaseEnterPhoneNumber: 'Please enter phone number',
    phoneFormatError: 'Please enter a valid phone number format',
    phoneBindSuccess: 'Phone number bound successfully',
    phoneChangeSuccess: 'Phone number changed successfully',
    pleaseEnterVerificationCode: 'Please enter verification code',
    verificationCodeSent: 'Verification code sent, please check',
    verificationCodeExpired: 'Verification code has expired, please resend',
    verificationCodeError: 'Verification code is incorrect, please re-enter',
    logoutFailed: 'Logout failed, please try again later',
    pleaseEnterPhoneFirst: 'Please enter phone number first',
    phoneAlreadyBound: 'This phone number is already bound, please use another number',
    pleaseLoginFirst: 'Please log in first',
    pleaseSelectImageFile: 'Please select an image file',
    imageSizeTooLarge: 'Image size cannot exceed 5MB',
    avatarUploadSuccess: 'Avatar uploaded successfully',
    previewFailed: 'Preview failed'
  },

  // Chat/AI Assistant Module
  chat: {
    aiAssistant: 'AI Tutor',
    markAsRead: 'Mark as Read',
    className: 'Class Name',
    ok: 'OK',
    copy: 'Copy',
    knowledgeRelation: 'Knowledge Relation',
    courseResources: 'Course Resources',
    webResources: 'Web Resources',
    guessYouWant: 'FAQ',
    youCanAsk: 'youCanAsk',
    assistant24h: '24h AI Study TA',
    aiAgent: 'Agent',
    chineseLang: 'Chinese',
    knowledgePoint: 'Syllabus',
    courseWork: 'Coursework',
    pleaseInput: 'Enter your question for the AI teaching assistant/agent.',
    send: 'Send',
    view: 'View',
    switchAssistantMode: 'Switch AI Tutor',
    // Tutor mode / personality picker on the shared (visitor) chat page
    modePickerTitle: 'Select Mode',
    stylePickerTitle: 'Select Personality',
    modeSwitched: 'Mode switched',
    styleSwitched: 'Personality switched',
    basicAssistant: 'Basic AI Tutor',
    specialAssistant: 'Special AI Tutor',
    currentAssistant: 'Current',
    yesterday: 'Yesterday',
    today: 'Today',
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun',

    // External link confirm modal in chat rich text
    externalLinkTitle: 'Open External Link',
    externalLinkDesc: 'This link is an AI reference. The content is provided by a third-party website. Please confirm the link source is reliable before continuing.',
    externalLinkTarget: 'Target: ',
    continueVisit: 'Continue',

    // Assistant Settings Modal
    selectTutorMode: 'Select TA Mode',
    selectTutorModePlaceholder: 'Please select TA mode',
    selectChatStyle: 'TA Personality',
    selectChatStylePlaceholder: 'Please select TA personality',
    celebrityName: 'Celebrity Name',
    celebrityNamePlaceholder: 'Please enter celebrity name, e.g.: Jay Chou',
    celebrityStyle: 'Celebrity',
    pleaseInputCelebrityName: 'Please enter celebrity name',
    saveSettings: 'Save',
    settingSaved: 'Setting Successful',

    // Tutor Modes
    normalMode: 'Normal Mode',
    guideMode: 'Guide Mode',
    mentorMode: 'Mentor Mode',
    partnerMode: 'Partner Mode',
    expertMode: 'Expert Mode',
    coachMode: 'Coach Mode',
    exampleMode: 'Example Mode',

    // Language Styles
    normalStyle: 'Default',
    professionalStyle: 'Professional',
    humorousStyle: 'Humorous',
    rigorousStyle: 'Rigorous',
    friendlyStyle: 'Friendly',
    sarcasticStyle: 'Sassy',
    praiseStyle: 'Cheerleader',
    supportiveStyle: 'Sidekick',

    // Notice Type Tags
    noticeTag: {
      task: 'Task',
      course: 'Course',
      errorExercise: 'Error Exercise',
      notice: 'Notice'
    },

    // Task Notifications
    newTaskNotification: 'Ding! New learning task unlocked! Submit by {date} {time} Latecomers get zero! →',
    taskContentUpdated: 'Ding! Task Content Updated! →',
    taskDeadlineUpdated: 'Ding! Deadline Updated! New Due: {date} {time} →',

    // Footer Disclaimer
    aiDisclaimer: 'This AI Tutor is powered by ({img}). AI-generated content needs verification. Please contact customer service if you have any questions.',
    aiDisclaimer2: 'This AI Tutor is powered by ({img})',
    noCourseEnrolled: 'You haven\'t enrolled in any courses yet. You can use the AI Tutor only after enrolling in a course.',

    // Empty State
    noCourseTitle: 'You haven\'t enrolled in any courses yet',
    noCourseDesc: 'You can use the AI Tutor only after enrolling in a course',

    //语音输入
    voiceInput: 'Voice input',
    stopVoiceInput: 'Stop voice input',
    sending: 'Sending...',
    aiThinking: 'My little brain is swimming in the ocean of knowledge, trying to find the best answer for you!',

    // 多模态
    camera: 'Camera',
    filesAndImages: 'Files & Images',
    images: 'Images',
    files: 'Files',
    fileStatusUploading: 'Uploading',
    fileStatusFailed: 'Failed',
    fileStatusProcessing: 'Processing',
    fileStatusSuccess: 'Ok',
    fileStatusParseFailed: 'Failed',
    sendWaitUploadingTip: 'Wait for upload & processing before sending',
    sendFailedAttachmentTip: 'Some files failed. Retry or delete, then send again',
    sendNoContentTip: 'Please enter content before sending',
    sendConnectingTip: 'AI tutor is connecting. Please try again shortly',
    selectAssistantTip: 'Please select an assistant first',
    sendAnsweringTip: 'Currently answering, please wait for the answer to complete before sending',
    sendRecordingTip: 'Currently recording, please finish recording before sending',
    sendUnsupportedFormatTip: 'Unsupported file format',
    maxImagesTip: 'You can select up to {count} images',
    maxFilesTip: 'You can select up to {count} files',
    maxTotalTip: 'You can select up to {count} images or files',
    imageSizeLimitTip: 'Image size cannot exceed {size}MB',
    fileSizeLimitTip: 'File size cannot exceed {size}MB',
    attachmentParseFailedRetry: '{name} parsing failed. Please try again',
    attachmentUploadFailedRetry: '{name} upload failed. Please try again',
    answeringVoiceTip: 'Currently answering, please wait for the answer to complete before recording',
    languageSwitchSuccess: 'Language switched successfully',
    voiceInputNoText: 'No text detected',
    voiceInputRetry: 'Voice recognition failed, please try again',
    voiceUnsupportedLanguage: 'Voice input is not supported for this language',
    voiceWsFailed: 'WebSocket connection failed',
    microphonePermissionDenied: 'Microphone permission denied. Voice input is unavailable',
    microphoneNoDevice: 'No microphone detected on this device. Voice input is unavailable',
    voiceStartFailed: 'Failed to start recording. Please try again later',
    voiceBrowserUnsupported: 'This browser does not support recording or WebSocket',
    retake: 'Retake',
    confirm: 'Confirm',
    cancel: 'Cancel',
    takePhoto: 'Take Photo',
    upload: 'Upload',
    cameraUnsupported: 'This browser does not support photo capture. Please upload files or images instead',
    cameraPermissionDenied: 'Camera permission denied. Photo capture is unavailable',
    cameraNoDevice: 'No camera device detected',
    cameraNoDeviceWithUploadTip: 'No camera device detected. Please upload files or images instead',
    cameraUnavailable: 'Photo capture is currently unavailable. Please try again later',
    cameraSwitchUnsupported: 'This device does not support switching cameras',
    cameraNotReady: 'The camera is not ready yet. Please try again shortly',
    cameraCaptureFailed: 'Failed to take photo. Please try again',
    cameraCompressFailed: 'Failed to compress the photo. Please try again',
    cameraTakePhotoFirst: 'Please take a photo first',
    uploadTipSupport: 'Supported: {types}',
    uploadTipCount: 'Up to {total} files: images <= {images}, documents <= {files}',
    uploadTipSize: 'Per image <= {imageSize}MB, per file <= {fileSize}MB',
    uploadTooltipAllowedTypes: 'the currently allowed types',
    uploadTooltipSingleFile: 'Per file',
    uploadTooltipSingleImage: 'Per image',
    uploadTooltipContent: 'Supports {types}; {sizeLabel} up to {size}MB',
    uploadTypePdf: 'PDF',
    uploadTypeWord: 'Word',
    uploadTypeExcel: 'Excel',
    uploadTypePpt: 'PowerPoint',
    uploadTypeImages: 'Images',
    dragUploadTitle: 'Drop files here to upload',
    maxInputTip: 'Up to {count} characters',
    noticeCradTitle: {
      ANSWER_PUBLISHED: 'Answer Published',
      NOTICE: 'Announcements',
      TASK_PUBLISHED: 'Task Published',
      TASK_PENDING: 'Task Pending',
      TASK_CHANGED: 'Task Updated',
      TASK_DEADLINE: 'Task Deadline',
      TASK_REJECTED: 'Task Rejected',
      WRONG_EXERCISE_FINAL: 'Final · Error Review',
      WRONG_EXERCISE_MIDTERM: 'Midterm · Error Review',
      WRONG_EXERCISE_OTHER: 'Other · Error Review',
      EXAM_NOTICE: 'EXAM NOTICE',
      EXAM_DEADLINE: 'EXAM DEADLINE',
      EXAM_SCORE_PUBLISHED: 'EXAM SCORE PUBLISHED',
      CALL_TASK_CALLED: 'Selection Notification',
      RUSH_TASK_STARTED: 'Rush Answer Published',
    }
  },

  // Course Info Module
  courseInfo: {
    title: 'Course Details',
    all: 'All',
    courseIntro: 'Course Introduction',
    knowledgePoint: 'Syllabus',
    tasks: 'Tasks',
    review: 'Review & Practice',
    errorReview: 'Error Practice',
    teacher: 'Teacher',
    assistant24h: '24h AI Study TA',
    curiosityQuestion: 'Curiosity Q&A',
    files: ' files',
    chapter: 'Chapter',
    week: 'Week',
    weekNum: 'Week {num}',
    firstWeek: 'Week 1',
    secondWeek: 'Week 2',
    thirdWeek: 'Week 3',
    homework: 'Homework',
    exam: 'Exam',
    resource: 'Resource',
    notSubmitted: 'Not Submitted',
    submitted: 'Submitted',
    rejected: 'Rejected',
    finished: 'Finished',
    notPracticed: 'Not Practiced',
    practiced: 'Practiced',
    scoreUnit: 'Points',
    points: '{num} Points',
    collapse: 'Collapse',
    expand: 'Expand',
    taskScore: 'Task Score',
    currentTaskScore: 'Current Task Score',
    comment: 'Comment',
    aiComment: 'AI Comment',
    viewScoreComment: 'View Score and Comment',
    gotIt: 'Got it',
    askAI: 'Ask AI',
    sign: 'Check In',
    uploadByText: 'Text Entry',
    uploadByImg: 'Upload by Image',

    // Answer Process & Reasoning
    answerProcessTitle: 'Solution Approach & Process',
    answerProcessPlaceholder: 'Please enter your solution process or reasoning',
    answerProcessImageLimit: 'You can upload up to 3 images per question',
    answerProcessImageFormat: 'Only "jpg", "jpeg", "png", "bmp", "webp" formats are supported',
    answerProcessImageSize: 'Image size cannot exceed 10MB',
    answerProcessRequired: 'Please describe your solution process or upload an image',
    answerProcessSubmitFailedTitle: 'Submission Failed',
    answerProcessSubmitFailedContent: 'Some questions are missing the solution process. Please complete them before submitting.',
    view: 'View',
    courseTodo: 'Course Tasks',
    studyMaterials: 'Study Materials',

    // Knowledge Points
    emptyKnowledgeTip: 'This is the "unreclaimed area" of knowledge. Stay tuned—reclamation work is in full swing.',
    totalTopics: 'Total {num} Knowledge/Skill Points',
    skills: 'skills',
    knowledge: 'knowledge',

    // Tasks
    taskDetails: 'Task Details',
    taskContent: 'Task Content',
    submitTask: 'Submit Task',
    uploadFile: 'Upload File',
    saveDraft: 'Save Draft',
    supportedFormats: 'Supported Upload Formats',
    formatDescription: 'Files of types: doc, docx, md, xls, xlsx, ppt, pptx, pdf, individual file size ≤ 20MB; jpg, jpeg, png, bmp, individual file size ≤ 10MB; Mp4 files are supported; individual mp4 file size ≤ 50MB. A maximum of 10 files can be uploaded per task.',
    submissionTime: 'Submission Time',
    noTasksAvailable: 'No Tasks Available',
    noTasksTypeAvailable: 'No {type} Tasks Available',
    noCourseTodo: 'no course\'s Todo',
    taskDeadline: 'Task closed on {time}',
    taskDeadlineSubmit: 'Deadline: {time}',
    allowLateSubmission: 'Late submission allowed after {time}',
    cannotSubmit: 'Content cannot be submitted. Please consult the teacher if you have any questions',
    expiredNotSubmit: 'The task has expired, content cannot be submitted',
    askTeacher: 'Please consult the teacher if you have any questions',
    rejectReason: 'Reject Reason',
    rejectTime: 'Reject Time',
    rejectImages: 'Rejected Images',
    rejectedResubmitTip: 'Please revise and resubmit according to the feedback',
    currentTaskStatus: 'Current Task Status',
    paper: 'Paper',
    totalScore: 'Total Score',
    score: 'Points',
    pleaseEnterAnswer: 'Please enter the corresponding answer',
    pleaseSelectAnswer: 'Please select an answer',
    pleaseSelectAtLeastOptions: 'Please select at least {count} options',
    pleaseSelectAtMostOptions: 'Please select at most {count} options',
    pleaseFillAnswer: 'Please fill in the answer',
    pleaseInputAnswer: 'Please enter the answer',
    multipleChoiceRangeTip: '(Select at least {min} and at most {max} options)',
    referenceAnswer: 'Reference Answer',
    selfAnswer: 'Student Answer',
    analysis: 'Analysis',

    // Question Types
    singleChoice: '. Single Choice ({count} Questions, {score} Points)',
    multipleChoice: '. Multiple Choice ({count} Questions, {score} Points)',
    fillBlank: '. Fill in the Blanks ({count} Questions, {score} Points)',
    judgeQuestion: '. True or False ({count} Questions, {score} Points)',
    essayQuestion: '. Essay Questions ({count} Questions, {score} Points)',
    otherQuestion: '. {type} ({count} Questions, {score} Points)',
    otherQuestionDefault: 'Other Questions',

    // Question Type Names (for validation prompts)
    singleChoiceType: 'Single Choice',
    multipleChoiceType: 'Multiple Choice',
    fillBlankType: 'Fill in the Blanks',
    judgeQuestionType: 'True or False',
    essayQuestionType: 'Essay Questions',
    otherQuestionType: 'Other Questions',

    // Error Practice
    errorPractice: 'Error Practice',
    errorQuestion: 'Error Question',
    exerciseQuestion: 'Exercise Question',
    weakKnowledgeList: 'List of Weak Knowledge Points',
    mistakeQuestions: 'Mistaken Questions',
    submit: 'Submit',
    qIdx: 'Question Index',
    questionType: 'Question Type',
    questionNumber: 'Question Number',
    correspondingKnowledgePoint: 'Corresponding Knowledge Point',
    keyPointTested: 'Key Point Tested',
    studentCorrectRate: 'Student\'s Correct Rate',
    classAverageCorrectRate: 'Class Average Correct Rate',
    noErrorPracticeAvailable: 'No Error Practice Available Yet',
    questionUnfinished: 'Question Unfinished',
    saveDraftBtn: 'Save Draft',
    submitBtn: 'Submit',
    scoreLabel: 'Score',
    accuracy: 'Accuracy',

    // Bloom's Taxonomy - Assessment Points
    bloomRemember: 'Remember',
    bloomUnderstand: 'Understand',
    bloomApply: 'Apply',
    bloomAnalyze: 'Analyze',
    bloomEvaluate: 'Evaluate',
    bloomCreate: 'Create',

    // Others
    needHelp: 'Need Help? Ask AI Tutor',
    back: 'Back',

    // File upload related
    document: 'Document',
    pdf: 'PDF',
    spreadsheet: 'Spreadsheet',
    presentation: 'Presentation',
    video: 'Video',
    image: 'Image',
    zip: 'ZIP',
    maxFileCount: 'Cannot exceed {count} files',
    fileTypeTipTitle: 'File Type Tips',
    supportVideoTip: 'Supports mp4 files, max size 500M.',
    supportDocTip: '{types} files, max size 20M;',
    fileLimitTip: 'Supports {fileTypes} files, size {limit}M per file',
    maxUploadCount: 'Up to {count} files per task.',
    notSupportFormat: 'Unsupported format',
    fileSizeExceeded: 'File size exceeded',
    fileSizeTip: '(mp4 max 500M, others max 50M)',
    fileExceedSize: 'The following files exceed {size} MB.',
    copyLinkTip: 'Copy the web link to go to ',
    copyDownloadLinkTip: 'Copy the download link and paste it in your mobile browser to download the file.',

    // Course Phase
    phase: {
      before: 'Before Class',
      during: 'In Class',
      after: 'After Class'
    },
    // Task Type
    taskType: {
      general: 'General Task',
      quiz: 'Quiz',
      bullet: 'Discussion',
      group: 'Group Task',
      vote: 'Poll',
      survey: 'Survey',
      notice: 'Notice',
      call: 'Tap Answer',
      rush: 'Rush Answer',
      exam: 'Exam',
      checkin: 'Check-in',
      wrongExercise: 'Error Review',
    },

    running: 'Running',
    pending: 'Pending',
    expired: 'Expired',
    deadlineLabel: 'Deadline: ',

    // 已读未读
    read: 'Read',
    unread: 'Unread',
    readTime: 'Reading Time',
    published: 'Published',
  },

  // Message Module
  message: {
    copySuccess: 'Copied successfully',
    // Common Messages
    success: 'Operation Successful!',
    error: 'Operation Failed',
    networkError: 'Network error, please check your connection!',
    requestTimeout: 'Request timeout, please try again later!',
    networkBusy: 'Network is busy, please try again later~',
    serverError: 'Server response error',
    dataIncomplete: 'Response data incomplete',
    operationFailed: 'Operation failed',
    operationFailedRetry: 'Operation failed, please try again later',
    getAssistantListFailed: 'Failed to get assistant list',
    unknownTime: 'Unknown time',
    logoutSuccess: 'Logged out successfully',

    // Question Related
    question: 'Question',
    questionNo: '',

    // Error Practice Messages
    missingRequiredParams: 'Missing required parameters',
    missingTaskParams: 'Missing task parameters',
    getErrorDetailFailed: 'Failed to get error details',
    exerciseSaved: 'Exercise saved',
    saveFailed: 'Save failed',
    submitSuccess: 'Submitted successfully',
    submitFailed: 'Submit failed',
    pleaseCompleteAtLeastOne: 'Please complete at least one practice question',
    confirmSubmit: 'Are you sure you want to submit? You cannot modify your answers after submission',
    confirmSubmitBtn: 'Confirm Submit',
    unansweredQuestions: 'The following questions have not been answered yet. Please complete them before submitting',
    gotIt: 'Got it',
    tip: 'Tip',
    cancel: 'Cancel',

    // Task-related Messages
    incompleteParams: 'Incomplete parameters, unable to retrieve task details',
    taskNotFound: 'Redirecting to error details...',
    getTaskDetailFailed: 'Failed to retrieve task details',
    taskInfoNotExist: 'Task information does not exist',
    taskNotExist: 'Task does not exist',
    saveSuccess: 'Saved successfully',
    notEditable: 'Current state is not editable',
    pleaseSelectImage: 'Please select an image file',
    imageSizeLimit: 'Image size cannot exceed 5MB',
    imageUploadSuccess: 'Image uploaded successfully',
    imageUploadFailed: 'Image upload failed, please try again later',
    imageDeleted: 'Image deleted',
    imageUploadedCannotEnterText: 'Image uploaded, cannot enter text',
    uploading: 'Uploading...',
    uploadingImage: 'Uploading image...',
    confirmSubmitTitle: 'Confirm Submission',
    confirmSubmitContent: 'You cannot modify the task after submission. Are you sure you want to submit?',
    unansweredWarning: 'The following questions have not been answered yet. Please complete them before submitting:',
    moreQuestions: 'and {count} more questions',
    pleaseInputTaskContent: 'Please enter task content',
    pleaseUploadFile: 'Please upload file',
    maxFileCountLimit: 'You can upload up to {count} files',
    fileSizeLimit: 'File {fileName} size cannot exceed {size}',
    fileUploadSuccess: '{fileName} uploaded successfully',
    fileUploadFailedWithName: '{fileName} upload failed: {error}',
    fileTypeNotAllowed: 'File type is not allowed. Please upload files with allowed types',
    someFilesTypeNotAllowed: 'Some files do not meet the type requirements and have been automatically filtered',
    tryAgainLater: 'Please try again later',
    submitting: 'Submitting...',
    noTaskInfo: 'No task information',

    // Login Related
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    loginFailedRetry: 'Login failed, please try again later',
    loginExpired: 'Login expired, please login again!',
    pleaseInputPhone: 'Please input phone number',
    pleaseInputCorrectPhone: 'Please input correct phone number',
    verifyCodeSent: 'Verification code sent',
    sendVerifyCodeFailed: 'Failed to send verification code',
    sendVerifyCodeFailedRetry: 'Failed to send verification code, please try again later',
    suggestBindPhone: 'We recommend binding a phone number for better service',
    pleaseBindStudentId: 'Please bind student ID',

    // Course Related
    noSemesterData: 'No semester data',
    loadedCourses: 'Loaded {count} courses',
    loadCourseFailed: 'Failed to load courses',
    pleaseInputClassCode: 'Please input class code',
    classNotFound: 'Class not found',
    foundClass: 'Found class: {name}',
    joinClassSuccess: 'Successfully joined class',
    joinClassFailed: 'Failed to join class',
    unlistedError: 'You are not on the class roster, and this class does not allow other students to join;If you are a class student, please contact the teacher to join the class roster',
    limitedError: 'The class has reached its maximum capacity. If you are a student in this class, please contact your teacher to be added to the roster',

    // WebSocket Related
    noAssistant: 'You haven\'t enrolled in any courses yet. You can use the AI Tutor only after enrolling in a course.',
    wsConnectSuccess: 'WebSocket connected',
    wsConnectError: 'WebSocket connection error',
    wsConnectClosed: 'WebSocket connection closed',
    connectFailed: 'Connection failed',
    pleaseInputQuestion: 'Please input your question',

    // Customer Service
    wechatScanCode: 'Scan with WeChat',
    contactCustomerService: 'Contact Customer Service',

    // Language Switch
    languageSwitched: 'Language Switch Successful'
  },

  imageEditor: {
    title: 'Image Editor',
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmUpload: 'Confirm Upload',
    continueEdit: 'Continue Editing',
    discardEditTitle: 'Discard Changes',
    discardEditContent: 'Discard your edits? Unsaved changes will be lost.',
    discardConfirm: 'Discard',
    saveFailed: 'Failed to save image edits. Please try again.',
    loadFailed: 'Failed to load image for editing.',
    imageLoading: 'Loading image...',
    noImage: 'No image',
    filePreview: 'File Preview',
    imagePreview: 'Image Preview',
    noFiles: 'No files',
    selectAtLeastOne: 'Please select at least one file',
    maxFiles: 'You can select up to {limit} files',
    editImage: 'Edit Image',
    edit: 'Edit',
    delete: 'Delete',
    defaultText: 'Tap to edit',
    undo: 'Undo',
    undoTip: 'Undo (Ctrl+Z)',
    restoreCrop: 'Reset Crop',
    restoreCropAndZoom: 'Reset crop and zoom',
    resetZoom: 'Reset Zoom',
    restoreRotate: 'Reset to before rotation',
    restore: 'Reset',
    reset: 'Reset',
    deleteSelectedText: 'Delete Selected Text',
    clearAnnotation: 'Clear',
    clearAnnotationTip: 'Clear all annotations',
    rotate: 'Rotate',
    rotateTip: 'Rotate 90°',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    crop: 'Crop',
    text: 'Text',
    addText: 'Add Text',
    annotation: 'Annotate',
    freeAnnotation: 'Freehand Annotation',
    confirmCrop: 'Apply Crop',
    cropRatio: 'Crop size',
    freeCrop: 'Free crop',
    confirmWithCount: 'Confirm ({count})',
    textEditDone: 'Done',
  },

  // Agent Square & Student-side Optimization
  agentSquare: {
    taskUnsubmitted: 'Unsubmitted',
    attendanceIssue: 'Attendance Issue',
    leaveClass: 'Leave',
    totalSessions: 'Total Sessions',
    unsubmittedTasks: 'Unsubmitted Tasks',
    attendanceRate: 'Attendance Rate',
    learningCenter: 'Learning Center',
    sessionDetail: 'Session Detail',
    xSessions: 'X Sessions',
    taskCenter: 'Task Center',
    xUnsubmitted: 'X Unsubmitted',
    attendanceCenter: 'Attendance Center',
    xAttendanceIssues: 'X Attendance Issues',
    aiTutor: 'AI Tutor',
    aiAgent: 'AI Agent',
    keyPoints: 'Knowledge/Skill',
    errorReview: 'Error Review',
    xTasks: 'X Tasks',
    xFiles: 'X Files',
    inClassTasks: 'In-class Tasks',
    classMaterials: 'Class Materials',
    sharedMaterials: 'Shared Materials',
    all: 'All',
    unsubmitted: 'Unsubmitted',
    returned: 'Returned',
    completed: 'Completed',
    noAgentsAvailable: 'No Agents Available',
    noAgents: 'No Agents',
    sourceAgentDeleted: 'This agent has been removed or unpublished by its creator',
    remove: 'Remove',
    removeConfirmTitle: 'Confirm Remove',
    removeConfirmContent: 'Remove "{name}" from your list? It will no longer appear here.',
    removeConfirmOk: 'Remove',
    removeSuccess: 'Removed successfully',
    removeFailed: 'Failed to remove',
    markAllReadSuccess: 'All marked as read',
    taskPublished: 'Published',
    taskUpdated: 'Updated',
    taskPending: 'Pending',
    taskReturned: 'Returned',
    taskDueSoon: 'Due Soon',
    finalExamErrorReview: 'Final · Error Review',
    midtermExamErrorReview: 'Midterm · Error Review',
    otherExamErrorReview: 'Other · Error Review',
    announcements: 'Announcements',
    view: 'View',
    groupTask: 'Group Task',
    discussion: 'Discussion',
    quizPractice: 'Quiz Practice',
    generalTask: 'General Task',
    poll: 'Poll',
    survey: 'Survey',
    checkIn: 'Check-in',
    coldCall: 'Cold Call',
    buzzIn: 'Quick-Answer',
    exam: 'Exam',
    notice: 'Notice'
  },
  taskCard: {
    all: 'All',
    unfinished: 'Unfinished',
    finished: 'Completed',
    rejected: 'Returned',
    peerReviewing: 'Peer review',
    peerReviewPending: 'Peer review pending',
    peerReviewProgress: 'Reviewed {filled}/{total}',
    peerReviewPendingSubmit: 'Reviewed {filled}/{total} (pending submit)',
    remainDays: '{n}d left',
    remainHours: '{n}h left',
    remainUnderHour: 'Less than 1h left',
    overdueDays: '{n}d overdue',
    overdueHours: '{n}h overdue',
    overdueHour: '1h overdue',
    cannotSubmit: 'Closed',
    inProgress: 'In progress',
    canLateSubmit: 'Late submission open',
    deadline: 'Due {time}',
    publishedAt: 'Published {time}',
    rounds: '{n} rounds',
    drawnRounds: 'Called {n}',
    notDrawn: 'Not called',
    grabbedRounds: 'Won {n}',
    notGrabbed: 'Missed',
    notJoined: 'Not joined',
    absent: 'Absent',
    fullAttendance: 'Full attendance',
    signedRounds: 'Checked in {n}',
    scoreUnit: 'pts',
    returnedResubmit: 'Returned. Please resubmit',
    noTasksYet: 'No tasks published yet',
    newTasksAppear: 'New tasks will show up here',
    noStatusTasks: 'No {name} tasks this term',
    switchStatusHint: 'Try another status, or jump weeks from the top left',
    noClassTasks: 'No tasks in this session',
    noClassStatusTasks: 'No {name} tasks in this session',
    switchStatus: 'Try another status',
    noMaterials: 'No materials in this session',
    noClassrooms: 'No sessions',
    classroomsAppear: 'Sessions will show up here once published',
    weekGuide: 'Newest weeks first. Scroll down for earlier weeks',
    jumpWeek: 'Jump to week',
    redDotLegend: 'A red dot means the week still has unfinished tasks you can submit',
    weekNum: 'Week {n}',
    thisWeek: 'current',
    totalPrefix: '',
    weekTotal: '{n} {unit}',
    loadFailed: 'Failed to load. Tap to retry',
    taskUnit: 'tasks',
    classUnit: 'sessions',
    taskWord: 'Tasks',
    tasksCompleted: 'Tasks completed',
    taskProgress: 'Tasks Done',
    files: 'Files',
    fileUnit: '',
    noTask: 'No tasks',
    noResource: 'No files',
    emptyTodo: 'No to-dos. Keep it up',
    emptyTodoHint: 'New tasks will be reminded here'
  }
}
